import { MouseEvent } from 'react';
import { Typography, UnstyledButton } from 'react-md';
import { StartPageTileData } from './const';

import styles from './start-page-tile.module.scss';

export function StartPageTile(tile: StartPageTileData) {
    const { title, imgSrc: _imgSrc, description, link, imgStyles } = tile;
    const { origin } = window.location;
    const imgSrc = origin + _imgSrc;

    const handleMouseDown = (event: MouseEvent) => {
        const isCtrl = event.ctrlKey || event.metaKey; // Mac = metaKey
        const isShift = event.shiftKey;
        const isMiddle = event.button === 1;

        if (isMiddle || isCtrl) {
            window.open(link, '_blank', 'noopener, noreferrer'); // New tab
        } else if (isShift) {
            window.open(link, '_blank', 'noopener, noreferrer, width=800, height=600'); // New window
        } else if (event.button === 0) {
            window.location.href = link; // Left click without modifiers
        }
        event.preventDefault();
    };

    return (
        <UnstyledButton key={link} className={styles['tile']} onMouseDown={handleMouseDown}>
            <div className={styles.preview}>
                <img src={imgSrc} alt={title} style={imgStyles} />
            </div>

            <Typography type="headline-3" className={styles.title}>
                {title}
            </Typography>

            {description}
        </UnstyledButton>
    );
}
